import SystemDevice from 'features/systems/domain/models/system-device';

export const getUnitLocationDeviceExternalId = (macAddress: string, address: string, unitLocation: string, number?: number): string => {
  return `${macAddress}_${address}_${unitLocation}${number ?? ''}`;
};

export const getLocalbusUnitPOEntryDeviceExternalId = (
  macAddress: string,
  address: string,
  localbusUnitReference: number,
  poEntryIndex: number,
): string => {
  return `${macAddress}_${address}_subunit_${localbusUnitReference}_${poEntryIndex}`;
};

export const getUnitLocationKey = (address: string | undefined, locationType: string, number?: number): string => {
  return `${address}_${locationType}_${number ?? ''}`;
};

export const getDevicesFromSystemForAddress = (devices: SystemDevice[] | undefined, address: string) => {
  if (!devices) {
    return [];
  }
  return devices.filter((device) => {
    const deviceExternalId = device.externalId;
    const deviceAddress = deviceExternalId?.split('_')[1];
    return deviceAddress === address;
  });
};

export const getLocationFromDeviceExternalId = (externalId: string): string => {
  const parts = externalId.split('_');
  if (parts.length < 3) {
    return '';
  }

  const location = parts[2];

  const match = /^([a-zA-Z]+)([1-8])$/.exec(location);

  if (match) {
    return `${match[1]} ${match[2]}`;
  }

  return location;
};
